export default __webpack_public_path__ + "static/media/ga.4a394ff8.png";